import { LayoutData } from "./layout.data";
import { LayoutElement } from "./layout.element";
import { MainLayout } from "./layout.main";
import { TypeClass } from "./layout.util";

window.LayDesigner = {
    selectedelement: undefined,
    init: function (args) {
        const mlay = new MainLayout()
        mlay.create({
            container: document.getElementById("lay-canvas-container"),
            selectCallback: (element) => {
                this.showProperty(element, mlay);
            },
            messageCallback: (msg) => {
                this.showMessage(msg)
            },
            cacheCallback: (val) => {
                this.setMenuEnable("lay-undo", val)
            }
        })
        this.initEvent(mlay, args)
        if (args.datasource) {
            if (TypeClass.checkType(args.datasource) == "string") {
                LayoutData.saveSource(args.datasource)
            } else if (TypeClass.checkType(args.datasource) == "json") {
                LayoutData.saveSource(JSON.stringify(args.datasource))
            }
        }
        if (args.template) {
            if (TypeClass.checkType(args.template) == "string") {
                mlay.importData(args.template)
            } else if (TypeClass.checkType(args.template) == "json") {
                mlay.importData(JSON.stringify(args.template))
            }
        }
    },
    initEvent: function (mlay, args) {
        const $ = layui.$
        const layer = layui.layer;
        const config = Object.assign({ savebtn: false, templateList: [], savefunc: () => { } }, args)
        if (config.savebtn) {
            $("#lay-save").show()
            $("#lay-save").click(() => {
                const data = mlay.getData();
                config.savefunc(JSON.stringify(data));
            })
        } else {
            $("#lay-save").hide()
        }
        $(".status-text").html("Peach Printer Web打印解决方案 讨论QQ群: 812982456")
        $("#lay-preivew").click(() => {
            const template = encodeURIComponent(JSON.stringify(mlay.getData()))
            const port = LayoutData.getPort()
            const datasource = encodeURIComponent(LayoutData.getSource())
            const license = encodeURIComponent(LayoutData.getLicense())
            const url = `http://127.0.0.1:${port}/preview`
            var httpRequest = new XMLHttpRequest();
            httpRequest.open("POST", url, true);
            httpRequest.setRequestHeader("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");
            httpRequest.onreadystatechange = () => {
                if (httpRequest.readyState == 4 && httpRequest.status == 200) {
                    var data = JSON.parse(httpRequest.responseText);
                    console.info(data);
                }
            }
            httpRequest.onerror = function () {
                layer.alert("Peach-Printer打印控件未启动", { icon: 5, title: '错误' })
            };
            httpRequest.send("template=" + template + "&license=" + license + "&datasource=" + datasource);

        })
        $("#lay-preivew2").click(() => {
            const template = JSON.stringify(mlay.getData())
            const datasource = LayoutData.getSource()
            PeachPrint.preview({ template: template, datasource: datasource });
        })

        $("#lay-convertpdf").click(() => {
            const template = encodeURIComponent(JSON.stringify(mlay.getData()))
            const port = LayoutData.getPort()
            const datasource = encodeURIComponent(LayoutData.getSource())
            const license = encodeURIComponent(LayoutData.getLicense())
            const url = `http://127.0.0.1:${port}/printPDF`
            var httpRequest = new XMLHttpRequest();
            httpRequest.open("POST", url, true);
            httpRequest.setRequestHeader("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");
            httpRequest.responseType = 'blob';
            httpRequest.onreadystatechange = () => {
                if (httpRequest.status == 200) {
                    let blob = httpRequest.response;
                    this.downfile(blob, mlay.getData().name + ".pdf");
                }
            }
            httpRequest.onerror = function () {
                layer.alert("Peach-Printer打印控件未启动", { icon: 5, title: '错误' })
            };
            httpRequest.send("template=" + template + "&license=" + license + "&datasource=" + datasource);
        })
        $("#lay-templecode").click(() => {
            const data = mlay.getData();
            const saveDatas = JSON.stringify(data, null, 2)
            this.openTempletCodeDialog(saveDatas)
        })
        $("#lay-download").click(() => {
            const data = mlay.getData();
            const saveDatas = JSON.stringify(data, null, 2)
            // 上面是拿到我自己的数据，数据的格式是Json字符串
            const blob = new Blob([saveDatas], { type: 'application/json' })
            const filename = `${data.name}-${Date.now()}.txt`
            this.downfile(blob, filename);
        })

        $("#lay-import").click(() => {
            $("#input-file").click()

        })

        $("#lay-undo").click(() => {
            console.info("rollback")
            mlay.rollback()
        })
        $("#lay-insert-line").click(() => {
            console.info("insert-line")
            mlay.addLine("0")
        })
        $("#lay-insert-ellipse").click(() => {
            console.info("insert-line")
            mlay.addLine("1")
        })
        $("#lay-insert-rect").click(() => {
            console.info("insert-line")
            mlay.addLine("2")
        })
        $("#lay-insert-text").click(() => {
            console.info("insert-text")
            mlay.addText()
        })
        $("#lay-insert-picture").click(() => {
            console.info("insert-picture")
            $("#input-image").click()
        })
        $("#lay-insert-barcode").click(() => {
            console.info("insert-barcode")
            layer.prompt((value, index, elem) => {
                layer.close(index);
                mlay.addBarcode(value)
            });
        })
        $("#lay-insert-qrcode").click(() => {
            console.info("insert-qrcode")
            layer.prompt({ formType: 2 }, (value, index, elem) => {
                layer.close(index);
                mlay.addQrcode(value)
            });
        })

        $("#lay-insert-list").click(() => {
            console.info("lay-insert-list")
            this.openListColsDialog(
                (dlg) => {
                    dlg.initData()
                },
                (dlg) => {
                    mlay.insertList(dlg.getData())
                })
        })


        $("#lay-delete").click(() => {
            console.info("delete")
            mlay.deleteElements()
        })

        $("#lay-aline-top").click(() => {
            console.info("aline-top")
            mlay.alineTop()
        })

        $("#lay-aline-bottom").click(() => {
            console.info("aline-bottom")
            mlay.alineBottom()
        })

        $("#lay-aline-left").click(() => {
            console.info("aline-left")
            mlay.alineLeft()
        })

        $("#lay-aline-right").click(() => {
            console.info("aline-right")
            mlay.alineRight()
        })


        $("#lay-moveup").click(() => {
            console.info("lay-moveup")
            mlay.moveup()
        })

        $("#lay-movedown").click(() => {
            console.info("lay-movedown")
            mlay.movedown()
        })


        layui.dropdown.render({
            elem: '#lay-temples',
            trigger: 'hover', // trigger 已配置在元素 `lay-options` 属性上
            data: config.templateList,
            click: (data, othis, event) => {
                this.loadTemplet(mlay, data.template, data.datasource);
            }
        });

        layui.dropdown.render({
            elem: '#lay-locat',
            trigger: 'hover', // trigger 已配置在元素 `lay-options` 属性上
            data: [
                { title: '注册码', id: 102 },
                { title: '数据源', id: 101 }
            ],
            click: (data, othis, event) => {
                if (data.id == 101) {
                    this.openSourceDialog();
                } else if (data.id == 102) {
                    this.openLicenseDialog();
                }
            }
        });

        // 自定义事件
        layui.dropdown.render({
            elem: '#lay-system',
            trigger: 'hover', // trigger 已配置在元素 `lay-options` 属性上
            data: [{
                title: '打印代码示例',
                id: 103
            }, {
                title: '关于软件',
                id: 102
            }],
            click: (data, othis, event) => {
                if (data.id == 102) {
                    this.openAboutDialog();
                } else if (data.id == 103) {
                    this.openExampleDialog();
                }
            }
        });






        $("#input-image").change(() => {
            this.importImage("input-image", (data) => {
                mlay.addPicture(data)
            })
        })

        $("#input-chromato").change(() => {
            this.importImage("input-chromato", (data) => {
                mlay.addChromato(data)
            })
        })

        $("#input-file").change(() => {
            //获取读取我文件的File对象
            const selectedFile = document.getElementById('input-file').files[0];
            //const name = selectedFile.name;//读取选中文件的文件名
            //const size = selectedFile.size;//读取选中文件的大小
            const reader = new FileReader();//这是核心,读取操作就是由它完成.
            reader.onload = () => {
                $("#input-file").val("")
                if (reader.readyState == 2) {
                    mlay.importData(reader.result)
                }
            }
            reader.readAsText(selectedFile);
        })
    },
    showProperty: function (element, mlay) {
        if (element.cls == LayoutElement.ELEMENT_LINE) {
            this.showLineElement(element, mlay)
        } else if (element.cls == LayoutElement.ELEMENT_TEXT) {
            this.showTextElement(element, mlay)
        } else if (element.cls == LayoutElement.ELEMENT_IMAGE) {
            this.showImageElement(element, mlay)
        } else if (element.cls == LayoutElement.ELEMENT_QRCODE) {
            this.showQrcodeElement(element, mlay)
        } else if (element.cls == LayoutElement.ELEMENT_BARCODE) {
            this.showBarcodeElement(element, mlay)
        } else if (element.cls == LayoutElement.ELEMENT_LIST) {
            this.showListElement(element, mlay)
        } else {
            this.showPaper(element, mlay)
        }
        this.selectedelement = element
    },
    showLineElement: function (element, mlay) {
        const $ = layui.$
        $("#property-title").text("形状属性")
        const setElementProperty = (element, mlay) => {
            this.initLocationWidgets(element, mlay)
            this.initColorWidget(element, mlay, "color")
            this.initSelectWidget(element, mlay, "weight")
            this.initSelectWidget(element, mlay, "type")
        }
        if (this.selectedelement === element) {
            setElementProperty(element, mlay)
        } else {
            $("#property-panel").load("./core/form/lineForm.html", () => {
                setElementProperty(element, mlay)
            })
        }
    },
    showTextElement: function (element, mlay) {
        const $ = layui.$
        $("#property-title").text("文本属性")
        const setElementProperty = (element, mlay) => {
            this.initLocationWidgets(element, mlay)
            this.initColorWidget(element, mlay, "color")
            this.initInputWidget(element, mlay, "text")
            this.initSelectWidget(element, mlay, "font")
            this.initSelectWidget(element, mlay, "size")
            this.initButtonCheckBoxWidget(element, mlay, "overflow")
            this.initButtonCheckBoxWidget(element, mlay, "bold")
            this.initButtonCheckBoxWidget(element, mlay, "italic")
            this.initButtonRadioBoxWidget(element, mlay, "align")
            this.initButtonRadioBoxWidget(element, mlay, "type")
            this.initButtonRadioBoxWidget(element, mlay, "vertical")
        }
        if (this.selectedelement === element) {
            setElementProperty(element, mlay)
        } else {
            $("#property-panel").load("./core/form/textForm.html", () => {
                setElementProperty(element, mlay)
            })
        }

    },
    showImageElement: function (element, mlay) {
        const $ = layui.$
        $("#property-title").text("图片属性")
        const setElementProperty = (element, mlay) => {
            this.initLocationWidgets(element, mlay)
            this.initInputWidget(element, mlay, "url")
        }
        if (this.selectedelement === element) {
            setElementProperty(element, mlay)
        } else {
            $("#property-panel").load("./core/form/imageForm.html", () => {
                setElementProperty(element, mlay)
            })
        }

    },
    showBarcodeElement: function (element, mlay) {
        const $ = layui.$
        $("#property-title").text("条码属性")
        const setElementProperty = (element, mlay) => {
            this.initLocationWidgets(element, mlay)
            this.initButtonRadioBoxWidget(element, mlay, "type")
            this.initInputWidget(element, mlay, "code")
        }
        if (this.selectedelement === element) {
            setElementProperty(element, mlay)
        } else {
            $("#property-panel").load("./core/form/barcodeForm.html", () => {
                setElementProperty(element, mlay)
            })
        }
    },
    showQrcodeElement: function (element, mlay) {
        const $ = layui.$
        $("#property-title").text("二维码属性")
        const setElementProperty = (element, mlay) => {
            this.initLocationWidgets(element, mlay)
            this.initButtonRadioBoxWidget(element, mlay, "type")
            this.initInputWidget(element, mlay, "code")
        }
        if (this.selectedelement === element) {
            setElementProperty(element, mlay)
        } else {
            $("#property-panel").load("./core/form/qrcodeForm.html", () => {
                setElementProperty(element, mlay)
            })
        }

    },
    showListElement(element, mlay) {
        const $ = layui.$
        $("#property-title").text("列表属性")
        const setElementProperty = (element, mlay) => {
            this.initLocationWidgets(element, mlay)
            this.initInputCheckBoxWidget(element, mlay, "border")
            this.initSelectWidget(element, mlay, "borderWeight")
            this.initColorWidget(element, mlay, "borderColor")
            this.initInputCheckBoxWidget(element, mlay, "title")
            this.initNumberWidget(element, mlay, "titleHeight", 100)
            this.initButtonCheckBoxWidget(element, mlay, "rowfill")
            this.initButtonCheckBoxWidget(element, mlay, "footerfill")
            this.initNumberWidget(element, mlay, "rowHeight", 100)
            this.initInputCheckBoxWidget(element, mlay, "footer")
            this.initNumberWidget(element, mlay, "footerHeight", 100)
            this.initInputWidget(element, mlay, "rowdata")

            this.initIconCheckBoxWidget(element, mlay, "footerTop")
            this.initIconCheckBoxWidget(element, mlay, "footerLeft")
            this.initIconCheckBoxWidget(element, mlay, "footerRight")
            this.initIconCheckBoxWidget(element, mlay, "footerBottom")
            this.initIconCheckBoxWidget(element, mlay, "footerInside")
            this.initIconCheckBoxWidget(element, mlay, "titleTop")
            this.initIconCheckBoxWidget(element, mlay, "titleLeft")
            this.initIconCheckBoxWidget(element, mlay, "titleRight")
            this.initIconCheckBoxWidget(element, mlay, "titleBottom")
            this.initIconCheckBoxWidget(element, mlay, "titleInside")
            this.initIconCheckBoxWidget(element, mlay, "rowTop")
            this.initIconCheckBoxWidget(element, mlay, "rowLeft")
            this.initIconCheckBoxWidget(element, mlay, "rowRight")
            this.initIconCheckBoxWidget(element, mlay, "rowBottom")
            this.initIconCheckBoxWidget(element, mlay, "rowInsideV")
            this.initIconCheckBoxWidget(element, mlay, "rowInsideH")
        }
        if (this.selectedelement === element) {
            setElementProperty(element, mlay)
        } else {
            $("#property-panel").load("./core/form/listForm.html", () => {
                setElementProperty(element, mlay)
                $("#form-button-cols").click(() => {
                    this.openListColsDialog(
                        (dlg) => {
                            dlg.setData(element.cols)
                        },
                        (dlg) => {
                            mlay.updateListCols(element, dlg.getData())
                        })
                })
            })
        }
    },
    showPaper: function (element, mlay) {
        const $ = layui.$
        $("#property-title").text("模版属性")


        const setElementProperty = (element, mlay) => {
            this.initNumberWidget(element, mlay, "width", 1)
            this.initNumberWidget(element, mlay, "height", 1)
            this.initNumberWidget(element, mlay, "offsetX", 1)
            this.initNumberWidget(element, mlay, "offsetY", 1)
            this.initNumberWidget(element, mlay, "copies", 1)
            this.initInputWidget(element, mlay, "name")
            this.initInputWidget(element, mlay, "paperName")
            this.initInputWidget(element, mlay, "printerName")
            this.initSelectWidget(element, mlay, "direction")
            this.initInputCheckBoxWidget(element, mlay, "bgshow")
            this.initSelectWidget(element, mlay, "paperType", (val) => {
                if (val == 'A4') {
                    this.updateWidgetValue(element, mlay,
                        { width: 210, height: 297, paperName: "A4" }
                    );
                    this.updateWidgetEnable(['width', 'height', 'paperName'], false);
                } else if (val == 'A5') {
                    this.updateWidgetValue(element, mlay,
                        { width: 148, height: 210, paperName: "A5" }
                    );
                    this.updateWidgetEnable(['width', 'height', 'paperName'], false);
                } else if (val == 'A6') {
                    this.updateWidgetValue(element, mlay,
                        { width: 105, height: 148, paperName: "A6" }
                    );
                    this.updateWidgetEnable(['width', 'height', 'paperName'], false);
                } else if (val == 'fit') {
                    this.updateWidgetValue(element, mlay, { paperName: "高度自适应" });
                    this.updateWidgetEnable(['width', 'height', 'paperName'], true);
                } else {
                    this.updateWidgetValue(element, mlay, { paperName: "自定义" });
                    this.updateWidgetEnable(['width', 'height', 'paperName'], true);
                }
            });
        }
        if (this.selectedelement === element) {
            setElementProperty(element, mlay)
        } else {
            $("#property-panel").load("./core/form/paperForm.html", () => {
                setElementProperty(element, mlay)
                $("#form-button-chromato-add").click(() => {
                    $("#input-chromato").click()
                })
            })
        }
    },
    updateWidgetValue: function (element, mlay, data) {
        const $ = layui.$
        for (var field in data) {
            $("#form-" + field).val(data[field]);
            element[field] = data[field]
        }
        mlay.refresh()
    },

    updateWidgetEnable: function (forms, enable) {
        const $ = layui.$
        forms.forEach((wg) => {
            $("#form-" + wg).attr('disabled', !enable);
        })

    },
    initLocationWidgets: function (element, mlay) {
        const $ = layui.$
        this.initNumberWidget(element, mlay, "ax1", 100);
        this.initNumberWidget(element, mlay, "ay1", 100);
        this.initNumberWidget(element, mlay, "ax2", 100);
        this.initNumberWidget(element, mlay, "ay2", 100);
    },
    initNumberWidget: function (element, mlay, field, ratio) {
        const $ = layui.$
        $("#form-" + field).val(parseInt(element[field] * ratio))
        $("#form-" + field).off("input").on("input", function () {
            mlay.updateElement(element, field, ($(this).val() / ratio))
        })
        $("#form-" + field).off("change").on("change", function () {
            mlay.savecache()
        })

    },
    initColorWidget: function (element, mlay, field) {
        const $ = layui.$
        $("#form-" + field).val(element[field])
        $("#form-" + field).off("change").on("change", function () {
            mlay.updateElement(element, field, $(this).val())
            mlay.savecache()
        })
    },
    initInputWidget: function (element, mlay, field) {
        const $ = layui.$
        $("#form-" + field).val(element[field])
        // $("#form-" + field).on("input", function () {
        //     element[field] = $(this).val()
        //     mlay.refresh()
        // })
        $("#form-" + field).off("change").on("change", function () {
            mlay.updateElement(element, field, $(this).val())
            mlay.savecache()
        })

    },
    initSelectWidget: function (element, mlay, field, callback) {
        const $ = layui.$
        $("#form-" + field).val(element[field])
        $("#form-" + field).off("input").on("input", function () {
            mlay.updateElement(element, field, $(this).val())
            if (callback) callback(element[field]);
        })
        $("#form-" + field).off("change").on("change", function () {
            mlay.savecache()
        })
        if (callback) callback(element[field]);
    },
    initInputCheckBoxWidget: function (element, mlay, field) {
        const $ = layui.$
        $("#form-" + field).prop('checked', element[field])
        $("#form-" + field).off("change").on("change", function () {
            mlay.updateElement(element, field, $(this).prop('checked'))
            mlay.savecache()
        })

    },
    initButtonCheckBoxWidget(element, mlay, field) {
        const $ = layui.$
        if (element[field]) {
            $("#form-" + field).addClass("selected");
        } else {
            $("#form-" + field).removeClass("selected");
        }

        $("#form-" + field).off('click').on('click', function () {
            if ($(this).hasClass("selected")) {
                $(this).removeClass("selected");
                mlay.updateElement(element, field, false)
            } else {
                $(this).addClass("selected");
                mlay.updateElement(element, field, true)
            }
            mlay.savecache()
        })
    },
    initIconCheckBoxWidget(element, mlay, field) {
        const $ = layui.$
        if (element[field]) {
            $("#form-" + field).addClass("selected");
        } else {
            $("#form-" + field).removeClass("selected");
        }

        $("#form-" + field).off('click').on('click', function () {
            if ($(this).hasClass("selected")) {
                $(this).removeClass("selected");
                mlay.updateElement(element, field, false)
            } else {
                $(this).addClass("selected");
                mlay.updateElement(element, field, true)
            }
            mlay.savecache()
        })
    },
    initButtonRadioBoxWidget(element, mlay, field) {
        const $ = layui.$
        $(".form-button-radio[lay-radio='" + field + "']").removeClass("selected");
        $(".form-button-radio[lay-radio='" + field + "'][data-value='" + element[field] + "']").addClass("selected");
        $(".form-button-radio[lay-radio='" + field + "']").off('click').on('click', function () {
            $(".form-button-radio[lay-radio='" + field + "']").removeClass("selected");
            $(this).addClass("selected");
            if (element[field] != $(this).data("value")) {
                mlay.updateElement(element, field, $(this).data("value"))
                mlay.savecache()
            }
        })
    },
    openTempletCodeDialog: function (data) {
        const layer = layui.layer
        const $ = layui.$
        layer.open({
            type: 1, // page 层类型
            area: ['530px', '340px'],
            title: '模版JSON对象',
            shade: 0.6, // 遮罩透明度
            shadeClose: true, // 点击遮罩区域，关闭弹层
            anim: 0, // 0-6 的动画形式，-1 不开启
            content: `<pre class="layui-code code-demo" id="form-templet" lay-options="{theme: 'dark'}"></pre>`,
            btn: ['确定', '取消'],
            success: () => {
                layui.code({
                    elem: '#form-templet',
                    code: data,
                    copy: true,
                });
            },
            yes: (index, layero, that) => {
                layer.close(index);
            },
        });
    },
    openSourceDialog: function () {
        const layer = layui.layer
        const $ = layui.$
        layer.open({
            type: 1, // page 层类型
            area: ['530px', '340px'],
            title: '预览模版数据源',
            shade: 0.6, // 遮罩透明度
            shadeClose: true, // 点击遮罩区域，关闭弹层
            anim: 0, // 0-6 的动画形式，-1 不开启
            content: '<textarea id="form-datasource" style="width:500px;height:200px;margin:10px;resize:none;"></textarea>',
            btn: ['确定', '取消'],
            success: () => {
                $("#form-datasource").val(LayoutData.getSource())
            },
            yes: (index, layero, that) => {
                LayoutData.saveSource($("#form-datasource").val())
                layer.close(index);
            },
        });
    },
    openLicenseDialog: function () {
        const layer = layui.layer
        const $ = layui.$
        layer.open({
            type: 1, // page 层类型
            area: ['530px', '340px'],
            title: '软件注册码（保存至当前浏览器缓存，以供后续使用）',
            shade: 0.6, // 遮罩透明度
            shadeClose: true, // 点击遮罩区域，关闭弹层
            anim: 0, // 0-6 的动画形式，-1 不开启
            content: '<textarea id="form-datasource" style="width:500px;height:200px;margin:10px;resize:none;"></textarea>',
            btn: ['确定', '取消'],
            success: () => {
                $("#form-datasource").val(LayoutData.getLicense())
            },
            yes: (index, layero, that) => {
                LayoutData.saveLicense($("#form-datasource").val())
                layer.close(index);
            },
        });
    },
    openLoactDialog: function () {
        const layer = layui.layer
        layer.open({
            type: 2,
            area: ['500px', '210px'],
            skin: 'layui-layer-lan',
            content: './core/dialog/loactDialog.html',
            fixed: false, // 不固定
            maxmin: false,
            shadeClose: true,
            title: '本地服务配置',
            btn: ['关闭']
        });
    },
    openJavaScriptDialog: function (mlay) {
        const data = JSON.stringify(mlay.getData())
        const license = LayoutData.getLicense()
        const source = JSON.stringify(JSON.parse(LayoutData.getSource()))

    },
    openExampleDialog: function () {
        const layer = layui.layer
        layer.open({
            type: 2,
            area: ['900px', '400px'],
            skin: 'layui-layer-lan',
            content: './core/dialog/exampleDialog.html',
            fixed: false, // 不固定
            maxmin: false,
            shadeClose: true,
            title: '示例代码',
            btn: ['关闭']
        });
    },
    openAboutDialog: function () {
        const layer = layui.layer
        layer.open({
            type: 2,
            area: ['500px', '380px'],
            skin: 'layui-layer-lan',
            content: './core/dialog/aboutDialog.html',
            fixed: false, // 不固定
            maxmin: false,
            shadeClose: true,
            title: '关于',
            btn: ['关闭']
        });
    },
    openListColsDialog: function (successcallback, yescallback) {
        const layer = layui.layer
        layer.open({
            type: 2,
            area: ['1024px', '580px'],
            skin: 'layui-layer-lan',
            content: './core/dialog/listColDialog.html',
            fixed: false, // 不固定
            maxmin: false,
            shadeClose: true,
            title: '列表控件-列属性编辑',
            btn: ['确定', '取消'],
            success: function (layero, index, that) {
                successcallback(window[layero.find('iframe')[0]['name']])
            },
            yes: function (index, layero) {
                yescallback(window[layero.find('iframe')[0]['name']])
                layer.close(index);
            }
        });
    },
    openListRowsDialog: function (successcallback, yescallback) {
        const layer = layui.layer
        layer.open({
            type: 2,
            area: ['1024px', '600px'],
            skin: 'layui-layer-lan',
            content: './core/dialog/listRowDialog.html',
            fixed: false, // 不固定
            maxmin: false,
            shadeClose: true,
            title: '列表控件-行数据编辑',
            btn: ['确定', '取消'],
            success: function (layero, index, that) {
                successcallback(window[layero.find('iframe')[0]['name']])
            },
            yes: function (index, layero) {
                yescallback(window[layero.find('iframe')[0]['name']])
                layer.close(index);
            }
        });
    },
    loadTemplet: function (mlay, tempurl, dataurl) {
        this.remoteFile(dataurl, (data) => {
            mlay.importData(data)
        })
        this.remoteFile(tempurl, (data) => {
            LayoutData.saveSource(data)
        })
    },
    showMessage: function (msg) {
        layui.layer.msg(msg, { time: 1000 });
    },
    importImage: function (elemid, callback) {
        const $ = layui.$
        //获取读取我文件的File对象
        const selectedFile = document.getElementById(elemid).files[0];
        //const name = selectedFile.name;//读取选中文件的文件名
        //const size = selectedFile.size;//读取选中文件的大小
        const reader = new FileReader();//这是核心,读取操作就是由它完成.
        reader.onload = () => {
            $(`#${elemid}`).val("")
            if (reader.readyState == 2) {
                callback(reader.result)
            }
        }
        reader.readAsDataURL(selectedFile);
    },
    downfile: function (blob, name) {
        if ("msSaveOrOpenBlob" in navigator) {
            // 这个判断要不要都行，如果是IE浏览器，使用的是这个，
            window.navigator.msSaveOrOpenBlob(blob, name);
        } else {    // 不是IE浏览器使用的下面的
            const url = window.URL.createObjectURL(blob)
            // 上面这个是创建一个blob的对象连链接，
            const link = document.createElement('a')
            // 创建一个链接元素，是属于 a 标签的链接元素，所以括号里才是a，
            link.href = url;
            // 把上面获得的blob的对象链接赋值给新创建的这个 a 链接
            link.setAttribute('download', name)
            // 设置下载的属性（所以使用的是download），这个是a 标签的一个属性
            // 后面的是文件名字，可以更改
            link.click();
            // 使用js点击这个链接
            window.URL.revokeObjectURL(url);
        }
    },
    remoteFile: function (url, callback) {
        fetch(url).then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.text()
        }).then(data => {
            callback(data)
        }).catch(error => {
            console.error('请求失败：', error);
        });
    },
    remoteJson: function (url, callback) {
        fetch(url).then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json()
        }).then(data => {
            callback(data)
        }).catch(error => {
            console.error('请求失败：', error);
        });
    },
    setMenuEnable: function (menu, val) {
        if (val) {
            layui.$("#" + menu).removeClass("layui-btn-disabled");
        } else {
            layui.$("#" + menu).addClass("layui-btn-disabled");
        }
    },

}